module.exports = __webpack_public_path__ + "static/evan-7c17530a94f647c2ac4ae490bb8075c9.jpeg";